import revive_payload_client_4sVQNw7RlN from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _00_offline_auth_bootstrap_client_0jSRf3TQse from "/home/runner/work/pos-frontend/pos-frontend/plugins/00-offline-auth-bootstrap.client.js";
import payload_client_yVLowv6hDl from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/runner/work/pos-frontend/pos-frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/pos-frontend/pos-frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_goSqzm8VLR from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt-papa-parse/dist/runtime/plugin.mjs";
import plugin_AOuQ1DYzjk from "/home/runner/work/pos-frontend/pos-frontend/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import _00_retire_service_worker_client_in9d86mDlx from "/home/runner/work/pos-frontend/pos-frontend/plugins/00-retire-service-worker.client.ts";
import chunk_recovery_client_bsNjehgEVA from "/home/runner/work/pos-frontend/pos-frontend/plugins/chunk-recovery.client.ts";
import offline_pos_client_hlrkVYa3As from "/home/runner/work/pos-frontend/pos-frontend/plugins/offline-pos.client.js";
import pos_reservation_client_z7aHh9jq01 from "/home/runner/work/pos-frontend/pos-frontend/plugins/pos-reservation.client.js";
import posthog_client_fUucxKWhZE from "/home/runner/work/pos-frontend/pos-frontend/plugins/posthog.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _00_offline_auth_bootstrap_client_0jSRf3TQse,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_goSqzm8VLR,
  plugin_AOuQ1DYzjk,
  chunk_reload_client_UciE0i6zes,
  _00_retire_service_worker_client_in9d86mDlx,
  chunk_recovery_client_bsNjehgEVA,
  offline_pos_client_hlrkVYa3As,
  pos_reservation_client_z7aHh9jq01,
  posthog_client_fUucxKWhZE
]